import * as actionTypes from 'login-actions/actionTypes';

export default (state: OnboardingState = {}, action: FluxStandardAction<any, any>) => {
  switch (action.type) {
    case actionTypes.SET_INITIAL_LOAN_TYPE:
      return {
        ...state,
        loanType: action.payload,
      };
    case actionTypes.ONBOARDING_FORM_ERROR:
      return {
        ...state,
        onboardingFormError: action.payload,
      };
    default:
      return state;
  }
};
